var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLateProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2500_118)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.1 658.801H475.199C441.542 658.801 414.273 631.517 414.273 597.876C414.273 564.22 441.558 536.936 475.199 536.936H811.1C818.516 536.936 824.52 542.939 824.52 550.355V645.382C824.52 652.798 818.516 658.801 811.1 658.801ZM475.199 637.044C496.832 637.044 514.367 619.51 514.367 597.876C514.367 576.242 496.832 558.708 475.199 558.708C453.565 558.708 436.03 576.242 436.03 597.876C436.03 619.51 453.565 637.044 475.199 637.044Z",
    fill: "url(#paint0_linear_2500_118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.437 330.592H674.082V287.078H680.377C707.139 287.078 729.541 305.641 735.437 330.592Z",
    fill: "url(#paint1_linear_2500_118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.847 597.876C396.847 641.144 431.916 676.212 475.184 676.212H803.132V765.404C803.132 796.665 777.797 822 746.552 822H231.099C199.854 822 174.52 796.665 174.52 765.404V343.658C174.52 312.412 199.854 287.078 231.099 287.078H242.968V330.592H237.794C226.892 330.592 218.048 339.436 218.048 350.337C218.048 361.238 226.892 370.098 237.794 370.098H746.552C777.797 370.098 803.132 395.417 803.132 426.678V519.524H475.184C431.916 519.524 396.847 554.608 396.847 597.876Z",
    fill: "url(#paint2_linear_2500_118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.019 177.051V357.032H621.851V275.501C618.427 276.238 614.88 276.637 611.226 276.637C583.726 276.637 561.432 254.343 561.432 226.844C561.432 223.205 561.816 219.643 562.568 216.219H354.49C355.242 219.643 355.626 223.205 355.626 226.844C355.626 254.343 333.332 276.637 305.832 276.637C302.178 276.637 298.631 276.238 295.207 275.501V357.032H256.039V177.051H661.019Z",
    fill: "url(#paint3_linear_2500_118)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint4_linear_2500_118)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint5_linear_2500_118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2500_118",
    x1: 619.397,
    y1: 536.936,
    x2: 619.397,
    y2: 658.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2500_118",
    x1: 704.76,
    y1: 287.078,
    x2: 704.76,
    y2: 330.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E8269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2500_118",
    x1: 488.826,
    y1: 287.078,
    x2: 488.826,
    y2: 822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E8269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462F59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2500_118",
    x1: 458.529,
    y1: 177.051,
    x2: 458.529,
    y2: 357.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B9C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2500_118",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2500_118",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2500_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLateProtection);
export default __webpack_public_path__ + "static/media/Logo_LateProtection.844d1c3c34abddf0abeddcc4f9af1694.svg";
export { ForwardRef as ReactComponent };